<template>

		<div class="floatWindow">
			<dl class="rel ke">
				<dt class="oper">
					<a href="javascript:void(0)" @click="customerService">
						<div class="kefu item">
							<div class="txt">
								<div>聯絡</div>
								<div>客服</div>
							</div>
						</div>
					</a>
				</dt>
			</dl>
			<dl class="rel ke">
				<dt class="oper">
					<a href="##"><div class="download item">
						<div class="txt"><div>APP</div> <div>下载</div> <div class="download_qr"><img src="~assets/images/app_dl.png" width="164" height="164" style=""></div></div></div>
					</a>
				</dt>
			</dl>
			<!-- <dl class="rel ke">
				<dt class="oper">
					<a href="javascript:void(0)" @click="LineCustomerService">
						<div class="phone item"><div class="txt"><div>LINE</div> <div>客服</div></div></div>
					</a>
				</dt>
			</dl> -->
			<!-- <dl class="rel ke">
				<dt class="oper">
					<router-link to="/help/trust" class=""></el-button>
						<div class="tel item"><div class="txt"><div>幫助</div> <div>中心</div></div></div>
					</router-link>

				</dt>
			</dl> -->
			<dl>
				<dt class="oper">
					<a href="javascript:void(0);" @click="backTop">
						<div class="top item"><div class="txt"><div>返回</div> <div>頂部</div></div></div>
					</a>
				</dt>
			</dl> <!----> <!---->
		</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {

		return {

		};
	},
	methods: {
		backTop(){
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		customerService(){
			//var url = 'http://kefu.ziyun.com.cn/vclient/chat/?websiteid=137063';
			window.open(this.config.CustomerServiceUrl,'', 'height=768,width=1024,location=no,menubar=no,menubar=no');
		},
		LineCustomerService(){
			window.open(this.config.LineCustomerServiceUrl,'', 'height=768,width=1024,location=no,menubar=no,menubar=no');
		}

	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
    },
	created() {

	}
}
</script>
<style scoped>
a, a:active, a:hover, a:link, a:visited {
    text-decoration: none;
    color: #6c6c6c;
}
.rel {
    position: relative;
}
.floatWindow {
    position: fixed;
    left: 50%;
    margin-left: 580px;
    bottom: 30px;
    z-index: 2;
}
.floatWindow .oper:hover {
    background: #409eff;
}
.floatWindow .oper:hover .txt {
    display: block;
}
.floatWindow dl {
    text-align: center;
}
.floatWindow dt {
    width: 48px;
    height: 48px;
    text-align: center;
    border: 1px solid #409eff;
    background: #fff;
    margin-bottom: 5px;
    border-radius: 5px;
}
.floatWindow .download_qr {
    position: relative;
    width: 164px;
    height: 164px;
    background-color: #000;
    z-index: 999;
    top: -50px;
    left: -174px;
}
.floatWindow .oper:hover .kefu, .floatWindow .oper:hover .tel, .floatWindow .oper:hover .top {
    background-image: inherit;
}
.floatWindow .download, .floatWindow .kefu, .floatWindow .phone, .floatWindow .tel, .floatWindow .top {
    background: url(~assets/images/floatBtn.png) no-repeat;
    background-position: 50%;
    margin-top: 9px;
    height: 32px;
    width: 32px;
}
.floatWindow .item {
    width: 48px;
    height: 48px;
    margin: auto;
    margin-bottom: 4px;
}
.floatWindow dt .txt {
    color: #fff;
    display: none;
	margin-top:5px;
	font-size:14px;
}

.floatWindow .kefu {
    background-position: 6px -1px;
}
.floatWindow .download {
    background-position: 6px -57px;
}
.floatWindow .phone {
    background-position: 6px -116px;
}
.floatWindow .tel {
    background-position: 6px -173px;
}
.floatWindow .top {
    background-position: 6px -225px;
}


</style>



// WEBPACK FOOTER //
// src/components/FloatButton.vue